import React from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { Placement } from 'react-bootstrap/esm/Overlay'

interface ITooltip {
  text: any
  className?: string
  position?: Placement
  delay?: any
  disabled?: boolean
  id?: string
}

const CommonToolTip: React.FC<ITooltip> = ({
  text,
  className = '',
  position = 'right',
  children,
  delay = { show: 250, hide: 400 },
  disabled,
  id = Math.random().toString(36).substring(2, 9),
}) => {
  const child = <span>{children} </span>
  return disabled ? (
    <> {children} </>
  ) : (
    <OverlayTrigger
      placement={position}
      delay={delay}
      overlay={
        <Tooltip className={className} id={id}>
          {text}
        </Tooltip>
      }
    >
      {child}
    </OverlayTrigger>
  )
}

export default CommonToolTip
